module.exports = __webpack_public_path__ + "img/Folded_Paper_dribbble-behance.40eb3397.svg";